/**
 * Internal dependencies
 */
import convertComplementaryAreas from './convert-complementary-areas';

export default function convertPreferencesPackageData( data ) {
	return convertComplementaryAreas( data );
}
